import { MODELS, useModel } from "../../api";
import { SparkShowroomOverviewWithData } from "../workshops/showroom/SparkShowroomOverviewWithData.jsx";
import { useSparkContext } from "../workshops/context/SparkContext.jsx";

/**
 * SparkShowroomOverview is a functional component responsible for rendering the showroom overview for a specific spark.
 * It uses route parameters to retrieve the sparkSlug and fetches the necessary data models required for the spark showroom.
 *
 * The component performs the following tasks:
 * - Retrieves the sparkSlug from route parameters using the `useParams` hook.
 * - Fetches the spark template model associated with the given sparkSlug.
 * - Fetches shared showroom entries for*/
const SparkShowroomOverview = () => {
  const { spark } = useSparkContext();

  const sharedEntries = useModel(
    MODELS.SPARK_SHARED_SHOWROOM_ENTRIES(spark.id),
  );

  return (
    <SparkShowroomOverviewWithData
      entries={sharedEntries}
      workshopSettings={spark.defaultSettings}
    />
  );
};

export default SparkShowroomOverview;
